/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DeadDrop
 * Agent coordination service with MCP and REST interfaces
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuthorizeV1OauthAuthorizeGetParams,
  BodyTokenV1OauthTokenPost,
  ClientRegistrationRequest,
  ClientRegistrationResponse,
  HTTPValidationError,
  OAuthAuthorizeRequest,
  OAuthAuthorizeResponse,
  OAuthClientMetadataResponse,
  OAuthClientSummary,
  OAuthErrorResponse,
  OAuthTokenResponse
} from '../model';

import { apiMutator } from '../../../lib/api-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * OAuth authorization endpoint (GET).
 *
 * Authenticated users receive parsed query params for topic selection.
 * Unauthenticated users receive 401 with WWW-Authenticate header (frontend redirects to login).
 * Invalid redirect_uri returns 400 error (no redirect for security).
 *
 * Frontend displays topic selection and permission consent form, then POSTs to /oauth/authorize.
 *
 * Example Request:
 *     GET /oauth/authorize?client_id=mcp_client&redirect_uri=http://localhost:3000/callback
 *     &response_type=code&scope=read_messages&state=random_csrf_token
 *     &code_challenge=E9Melhoa2OwvFrEMTJguCHaoeK1t8URWbuGJSstw-cM
 *     &code_challenge_method=S256
 *     Authorization: Bearer <user_access_token>
 *
 * Example Success Response (200):
 *     {
 *       "clientId": "mcp_client",
 *       "redirectUri": "http://localhost:3000/callback",
 *       "responseType": "code",
 *       "scopes": ["read_messages"],
 *       "state": "random_csrf_token",
 *       "codeChallenge": "E9Melhoa2OwvFrEMTJguCHaoeK1t8URWbuGJSstw-cM",
 *       "codeChallengeMethod": "S256"
 *     }
 *
 * Example Error Response - Invalid Redirect URI (400):
 *     {
 *       "detail": "Invalid redirect_uri. Must be valid HTTP(S) URL with scheme and host."
 *     }
 *
 * Example Error Response - Invalid Response Type (400):
 *     {
 *       "detail": "Invalid response_type. Only 'code' is supported."
 *     }
 *
 * Example Error Response - Unauthenticated (401):
 *     {
 *       "detail": "Not authenticated"
 *     }
 *     Headers: WWW-Authenticate: Bearer
 *
 * Args:
 *     request: FastAPI request for rate limiting
 *     client_id: OAuth client identifier (optional)
 *     redirect_uri: OAuth callback URL (required, validated)
 *     response_type: OAuth response type (must be "code")
 *     scope: Space-separated OAuth scopes (optional)
 *     state: CSRF protection token (optional)
 *     code_challenge: PKCE code challenge for enhanced security (optional)
 *     code_challenge_method: PKCE challenge method - "S256" only (optional)
 *     current_user: Authenticated user from Bearer token
 *
 * Returns:
 *     OAuthAuthorizeResponse with parsed parameters for frontend
 *
 * Raises:
 *     HTTPException 400: If redirect_uri invalid or response_type not "code"
 *     HTTPException 401: If user not authenticated (via get_current_user dependency)
 * @summary Authorize
 */
export const authorizeV1OauthAuthorizeGet = (
    params: AuthorizeV1OauthAuthorizeGetParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<OAuthAuthorizeResponse>(
      {url: `/v1/oauth/authorize`, method: 'GET',
        params, signal
    },
      options);
    }




export const getAuthorizeV1OauthAuthorizeGetQueryKey = (params?: AuthorizeV1OauthAuthorizeGetParams,) => {
    return [
    `/v1/oauth/authorize`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuthorizeV1OauthAuthorizeGetQueryOptions = <TData = Awaited<ReturnType<typeof authorizeV1OauthAuthorizeGet>>, TError = HTTPValidationError>(params: AuthorizeV1OauthAuthorizeGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authorizeV1OauthAuthorizeGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthorizeV1OauthAuthorizeGetQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authorizeV1OauthAuthorizeGet>>> = ({ signal }) => authorizeV1OauthAuthorizeGet(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authorizeV1OauthAuthorizeGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthorizeV1OauthAuthorizeGetQueryResult = NonNullable<Awaited<ReturnType<typeof authorizeV1OauthAuthorizeGet>>>
export type AuthorizeV1OauthAuthorizeGetQueryError = HTTPValidationError


export function useAuthorizeV1OauthAuthorizeGet<TData = Awaited<ReturnType<typeof authorizeV1OauthAuthorizeGet>>, TError = HTTPValidationError>(
 params: AuthorizeV1OauthAuthorizeGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authorizeV1OauthAuthorizeGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authorizeV1OauthAuthorizeGet>>,
          TError,
          Awaited<ReturnType<typeof authorizeV1OauthAuthorizeGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthorizeV1OauthAuthorizeGet<TData = Awaited<ReturnType<typeof authorizeV1OauthAuthorizeGet>>, TError = HTTPValidationError>(
 params: AuthorizeV1OauthAuthorizeGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authorizeV1OauthAuthorizeGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authorizeV1OauthAuthorizeGet>>,
          TError,
          Awaited<ReturnType<typeof authorizeV1OauthAuthorizeGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthorizeV1OauthAuthorizeGet<TData = Awaited<ReturnType<typeof authorizeV1OauthAuthorizeGet>>, TError = HTTPValidationError>(
 params: AuthorizeV1OauthAuthorizeGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authorizeV1OauthAuthorizeGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Authorize
 */

export function useAuthorizeV1OauthAuthorizeGet<TData = Awaited<ReturnType<typeof authorizeV1OauthAuthorizeGet>>, TError = HTTPValidationError>(
 params: AuthorizeV1OauthAuthorizeGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authorizeV1OauthAuthorizeGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthorizeV1OauthAuthorizeGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * OAuth authorization endpoint (POST).
 *
 * Implements two mutually exclusive flows per spec Section 2.2:
 *
 * Case 1 - First Authorization:
 *     - No existing OAuthClient for client type + user
 *     - Set user_id on OAuthClient during authorization
 *     - Create Connection with oauth_client_id, can_read=true, can_write=true
 *
 * Case 2 - Reconnection:
 *     - Existing OAuthClient found via find_oauth_client_by_name()
 *     - Call migrate_connections_to_client() to move connections
 *     - Delete old OAuthClient (within migration transaction)
 *
 * Transaction requirements per spec Section 7.5:
 *     - Atomic: user_id assignment + Connection creation
 *     - Rollback if Connection creation fails after user_id set
 *
 * Concurrency control per spec Section 7.6:
 *     - UNIQUE (user_id, client_name) constraint prevents duplicate authorizations
 *     - Return 409 Conflict on IntegrityError
 *
 * Example Request:
 *     POST /oauth/authorize
 *     Content-Type: application/json
 *     Authorization: Bearer <user_access_token>
 *
 *     {
 *       "clientId": "dd_client_xxx",
 *       "redirectUri": "http://localhost:3000/callback",
 *       "topicId": "550e8400-e29b-41d4-a716-446655440000",
 *       "scopes": ["read", "write"],
 *       "state": "random_csrf_token",
 *       "codeChallenge": "E9Melhoa2OwvFrEMTJguCHaoeK1t8URWbuGJSstw-cM",
 *       "codeChallengeMethod": "S256"
 *     }
 *
 * Example Success Response (200):
 *     {
 *       "redirect_url": "http://localhost:3000/callback?code=abc123def456&state=random_csrf_token"
 *     }
 *
 * Example Error Response - Topic Not Found (404):
 *     {
 *       "detail": "Topic 550e8400-e29b-41d4-a716-446655440000 not found"
 *     }
 *
 * Example Error Response - Duplicate Authorization (409):
 *     {
 *       "detail": "OAuth authorization already in progress for this client type"
 *     }
 *
 * Args:
 *     request: FastAPI request for rate limiting
 *     body: Authorization request with topic selection and OAuth parameters
 *     current_user: Authenticated user from Bearer token
 *
 * Returns:
 *     JSONResponse with redirect_url containing authorization code
 *
 * Raises:
 *     HTTPException 400: If redirect_uri invalid
 *     HTTPException 404: If topic not found
 *     HTTPException 403: If user doesn't own topic
 *     HTTPException 409: If duplicate authorization attempt (IntegrityError)
 * @summary Authorize Post
 */
export const authorizePostV1OauthAuthorizePost = (
    oAuthAuthorizeRequest: OAuthAuthorizeRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<unknown>(
      {url: `/v1/oauth/authorize`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: oAuthAuthorizeRequest, signal
    },
      options);
    }




export const getAuthorizePostV1OauthAuthorizePostMutationKey = () => ['authorizePostV1OauthAuthorizePost'] as const;

export const getAuthorizePostV1OauthAuthorizePostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authorizePostV1OauthAuthorizePost>>, TError,AuthorizePostV1OauthAuthorizePostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof authorizePostV1OauthAuthorizePost>>, TError,AuthorizePostV1OauthAuthorizePostMutationVariables, TContext> => {

const mutationKey = getAuthorizePostV1OauthAuthorizePostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authorizePostV1OauthAuthorizePost>>, AuthorizePostV1OauthAuthorizePostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  authorizePostV1OauthAuthorizePost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AuthorizePostV1OauthAuthorizePostMutationResult = NonNullable<Awaited<ReturnType<typeof authorizePostV1OauthAuthorizePost>>>
    export type AuthorizePostV1OauthAuthorizePostMutationBody = OAuthAuthorizeRequest
    export type AuthorizePostV1OauthAuthorizePostMutationError = HTTPValidationError
    export type AuthorizePostV1OauthAuthorizePostMutationVariables = {data: OAuthAuthorizeRequest}

    /**
 * @summary Authorize Post
 */
export const useAuthorizePostV1OauthAuthorizePost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authorizePostV1OauthAuthorizePost>>, TError,AuthorizePostV1OauthAuthorizePostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authorizePostV1OauthAuthorizePost>>,
        TError,
        AuthorizePostV1OauthAuthorizePostMutationVariables,
        TContext
      > => {
      return useMutation(getAuthorizePostV1OauthAuthorizePostMutationOptions(options), queryClient);
    }
    /**
 * List user's authorized OAuth clients with topic details.
 *
 * Returns all active OAuth clients for current user with connections grouped by topic.
 * Only includes clients that have at least one connection.
 *
 * Example Request:
 *     GET /oauth/clients
 *     Authorization: Bearer <user_access_token>
 *
 * Example Success Response (200):
 *     [
 *       {
 *         "clientId": "dd_client_xxx",
 *         "clientType": "chatgpt",
 *         "displayName": "ChatGPT",
 *         "authorizedAt": "2025-01-15T10:30:00Z",
 *         "topics": [
 *           {"id": "uuid", "name": "Development", "canRead": true, "canWrite": true}
 *         ]
 *       }
 *     ]
 *
 * Args:
 *     current_user: Authenticated user from Bearer token
 *
 * Returns:
 *     list[OAuthClientSummary]: List of authorized OAuth clients with topic details
 *
 * Raises:
 *     HTTPException 401: If user not authenticated (via get_current_user dependency)
 * @summary List Oauth Clients
 */
export const listOauthClientsV1OauthClientsGet = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<OAuthClientSummary[]>(
      {url: `/v1/oauth/clients`, method: 'GET', signal
    },
      options);
    }




export const getListOauthClientsV1OauthClientsGetQueryKey = () => {
    return [
    `/v1/oauth/clients`
    ] as const;
    }


export const getListOauthClientsV1OauthClientsGetQueryOptions = <TData = Awaited<ReturnType<typeof listOauthClientsV1OauthClientsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOauthClientsV1OauthClientsGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListOauthClientsV1OauthClientsGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listOauthClientsV1OauthClientsGet>>> = ({ signal }) => listOauthClientsV1OauthClientsGet(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listOauthClientsV1OauthClientsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListOauthClientsV1OauthClientsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listOauthClientsV1OauthClientsGet>>>
export type ListOauthClientsV1OauthClientsGetQueryError = unknown


export function useListOauthClientsV1OauthClientsGet<TData = Awaited<ReturnType<typeof listOauthClientsV1OauthClientsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOauthClientsV1OauthClientsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOauthClientsV1OauthClientsGet>>,
          TError,
          Awaited<ReturnType<typeof listOauthClientsV1OauthClientsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOauthClientsV1OauthClientsGet<TData = Awaited<ReturnType<typeof listOauthClientsV1OauthClientsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOauthClientsV1OauthClientsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOauthClientsV1OauthClientsGet>>,
          TError,
          Awaited<ReturnType<typeof listOauthClientsV1OauthClientsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListOauthClientsV1OauthClientsGet<TData = Awaited<ReturnType<typeof listOauthClientsV1OauthClientsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOauthClientsV1OauthClientsGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Oauth Clients
 */

export function useListOauthClientsV1OauthClientsGet<TData = Awaited<ReturnType<typeof listOauthClientsV1OauthClientsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listOauthClientsV1OauthClientsGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListOauthClientsV1OauthClientsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Revoke OAuth client and delete all associated connections.
 *
 * Deletes OAuth client and all connections using the client credentials.
 * Requires ownership verification before deletion.
 *
 * Example Request:
 *     DELETE /oauth/clients/dd_client_xxx
 *     Authorization: Bearer <user_access_token>
 *
 * Example Success Response (204):
 *     HTTP/1.1 204 No Content
 *
 * Example Error Response - Client Not Found (404):
 *     {
 *       "error": "OAuthClientNotFoundError",
 *       "detail": {
 *         "message": "OAuth client dd_client_xxx not found"
 *       },
 *       "path": "/oauth/clients/dd_client_xxx"
 *     }
 *
 * Example Error Response - Access Denied (403):
 *     {
 *       "error": "AccessDeniedError",
 *       "detail": {
 *         "message": "Access denied: OAuth client dd_client_xxx is not owned by user <user_id>"
 *       },
 *       "path": "/oauth/clients/dd_client_xxx"
 *     }
 *
 * Args:
 *     client_id: OAuth client identifier to revoke
 *     current_user: Authenticated user from Bearer token
 *
 * Raises:
 *     OAuthClientNotFoundError: If client not found (404)
 *     AccessDeniedError: If user doesn't own client (403)
 * @summary Delete Oauth Client
 */
export const deleteOauthClientV1OauthClientsClientIdDelete = (
    clientId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/v1/oauth/clients/${clientId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteOauthClientV1OauthClientsClientIdDeleteMutationKey = () => ['deleteOauthClientV1OauthClientsClientIdDelete'] as const;

export const getDeleteOauthClientV1OauthClientsClientIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOauthClientV1OauthClientsClientIdDelete>>, TError,DeleteOauthClientV1OauthClientsClientIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOauthClientV1OauthClientsClientIdDelete>>, TError,DeleteOauthClientV1OauthClientsClientIdDeleteMutationVariables, TContext> => {

const mutationKey = getDeleteOauthClientV1OauthClientsClientIdDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOauthClientV1OauthClientsClientIdDelete>>, DeleteOauthClientV1OauthClientsClientIdDeleteMutationVariables> = (props) => {
          const {clientId} = props ?? {};

          return  deleteOauthClientV1OauthClientsClientIdDelete(clientId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteOauthClientV1OauthClientsClientIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOauthClientV1OauthClientsClientIdDelete>>>

    export type DeleteOauthClientV1OauthClientsClientIdDeleteMutationError = HTTPValidationError
    export type DeleteOauthClientV1OauthClientsClientIdDeleteMutationVariables = {clientId: string}

    /**
 * @summary Delete Oauth Client
 */
export const useDeleteOauthClientV1OauthClientsClientIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOauthClientV1OauthClientsClientIdDelete>>, TError,DeleteOauthClientV1OauthClientsClientIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOauthClientV1OauthClientsClientIdDelete>>,
        TError,
        DeleteOauthClientV1OauthClientsClientIdDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteOauthClientV1OauthClientsClientIdDeleteMutationOptions(options), queryClient);
    }
    /**
 * OAuth 2.0 client metadata lookup endpoint (GET).
 *
 * Returns public client metadata for display during authorization consent flow.
 * Public endpoint (no authentication required) for OAuth client discovery.
 *
 * Only returns metadata for active clients. Returns 404 for non-existent,
 * suspended, or revoked clients to prevent client enumeration.
 *
 * Example Request:
 *     GET /oauth/clients/dd_client_1234567890abcdef.../metadata
 *
 * Example Success Response (200):
 *     {
 *       "clientId": "dd_client_1234567890abcdef...",
 *       "clientName": "My MCP Client",
 *       "logoUri": "https://example.com/logo.png",
 *       "clientUri": "https://example.com",
 *       "registeredAt": "2025-01-15T10:30:00Z",
 *       "isRegistered": true
 *     }
 *
 * Example Error Response - Client Not Found (404):
 *     {
 *       "detail": "Client dd_client_xyz not found"
 *     }
 *
 * Args:
 *     client_id: OAuth client identifier
 *
 * Returns:
 *     OAuthClientMetadataResponse with public client metadata
 *
 * Raises:
 *     HTTPException 404: If client not found or not active
 * @summary Get Client Metadata
 */
export const getClientMetadataV1OauthClientsClientIdMetadataGet = (
    clientId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<OAuthClientMetadataResponse>(
      {url: `/v1/oauth/clients/${clientId}/metadata`, method: 'GET', signal
    },
      options);
    }




export const getGetClientMetadataV1OauthClientsClientIdMetadataGetQueryKey = (clientId: string,) => {
    return [
    `/v1/oauth/clients/${clientId}/metadata`
    ] as const;
    }


export const getGetClientMetadataV1OauthClientsClientIdMetadataGetQueryOptions = <TData = Awaited<ReturnType<typeof getClientMetadataV1OauthClientsClientIdMetadataGet>>, TError = HTTPValidationError>(clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientMetadataV1OauthClientsClientIdMetadataGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientMetadataV1OauthClientsClientIdMetadataGetQueryKey(clientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientMetadataV1OauthClientsClientIdMetadataGet>>> = ({ signal }) => getClientMetadataV1OauthClientsClientIdMetadataGet(clientId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: clientId !== null && clientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClientMetadataV1OauthClientsClientIdMetadataGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientMetadataV1OauthClientsClientIdMetadataGetQueryResult = NonNullable<Awaited<ReturnType<typeof getClientMetadataV1OauthClientsClientIdMetadataGet>>>
export type GetClientMetadataV1OauthClientsClientIdMetadataGetQueryError = HTTPValidationError


export function useGetClientMetadataV1OauthClientsClientIdMetadataGet<TData = Awaited<ReturnType<typeof getClientMetadataV1OauthClientsClientIdMetadataGet>>, TError = HTTPValidationError>(
 clientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientMetadataV1OauthClientsClientIdMetadataGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientMetadataV1OauthClientsClientIdMetadataGet>>,
          TError,
          Awaited<ReturnType<typeof getClientMetadataV1OauthClientsClientIdMetadataGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientMetadataV1OauthClientsClientIdMetadataGet<TData = Awaited<ReturnType<typeof getClientMetadataV1OauthClientsClientIdMetadataGet>>, TError = HTTPValidationError>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientMetadataV1OauthClientsClientIdMetadataGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientMetadataV1OauthClientsClientIdMetadataGet>>,
          TError,
          Awaited<ReturnType<typeof getClientMetadataV1OauthClientsClientIdMetadataGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientMetadataV1OauthClientsClientIdMetadataGet<TData = Awaited<ReturnType<typeof getClientMetadataV1OauthClientsClientIdMetadataGet>>, TError = HTTPValidationError>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientMetadataV1OauthClientsClientIdMetadataGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Client Metadata
 */

export function useGetClientMetadataV1OauthClientsClientIdMetadataGet<TData = Awaited<ReturnType<typeof getClientMetadataV1OauthClientsClientIdMetadataGet>>, TError = HTTPValidationError>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientMetadataV1OauthClientsClientIdMetadataGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClientMetadataV1OauthClientsClientIdMetadataGetQueryOptions(clientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * OAuth 2.0 Dynamic Client Registration endpoint (POST).
 *
 * Registers new OAuth client with generated credentials per RFC 7591.
 * Public endpoint (no authentication required) for MCP client registration.
 *
 * Flow:
 * 1. Validate redirect_uris format and security requirements
 * 2. Generate client_id and client_secret via register_client()
 * 3. Store client metadata in database
 * 4. Return client credentials and metadata
 *
 * Example Request:
 *     POST /oauth/register
 *     Content-Type: application/json
 *
 *     {
 *       "clientName": "My MCP Client",
 *       "redirectUris": ["https://example.com/callback", "http://localhost:3000/callback"],
 *       "clientUri": "https://example.com",
 *       "logoUri": "https://example.com/logo.png",
 *       "contacts": ["admin@example.com"],
 *       "tosUri": "https://example.com/tos",
 *       "policyUri": "https://example.com/privacy",
 *       "softwareId": "mcp-client-v1",
 *       "softwareVersion": "1.0.0"
 *     }
 *
 * Example Success Response (201):
 *     {
 *       "clientId": "dd_client_1234567890abcdef...",
 *       "clientSecret": "abc123def456...",
 *       "clientName": "My MCP Client",
 *       "redirectUris": ["https://example.com/callback", "http://localhost:3000/callback"],
 *       "grantTypes": ["authorization_code"],
 *       "responseTypes": ["code"],
 *       "clientIdIssuedAt": 1704067200,
 *       "clientSecretExpiresAt": 0
 *     }
 *
 * Example Error Response - Invalid Redirect URI (400):
 *     {
 *       "detail": "Invalid redirect_uris. Must use https:// scheme or http://localhost, and contain no fragment components."
 *     }
 *
 * Example Error Response - Missing Client Name (400):
 *     {
 *       "detail": "client_name is required and must be a non-empty string"
 *     }
 *
 * Args:
 *     request: FastAPI request (reserved for future rate limiter)
 *     body: Client registration request with metadata
 *
 * Returns:
 *     ClientRegistrationResponse with client_id, client_secret, and metadata
 *
 * Raises:
 *     HTTPException 400: If redirect_uris invalid or required fields missing
 * @summary Register
 */
export const registerV1OauthRegisterPost = (
    clientRegistrationRequest: ClientRegistrationRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<ClientRegistrationResponse>(
      {url: `/v1/oauth/register`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: clientRegistrationRequest, signal
    },
      options);
    }




export const getRegisterV1OauthRegisterPostMutationKey = () => ['registerV1OauthRegisterPost'] as const;

export const getRegisterV1OauthRegisterPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerV1OauthRegisterPost>>, TError,RegisterV1OauthRegisterPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof registerV1OauthRegisterPost>>, TError,RegisterV1OauthRegisterPostMutationVariables, TContext> => {

const mutationKey = getRegisterV1OauthRegisterPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof registerV1OauthRegisterPost>>, RegisterV1OauthRegisterPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  registerV1OauthRegisterPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegisterV1OauthRegisterPostMutationResult = NonNullable<Awaited<ReturnType<typeof registerV1OauthRegisterPost>>>
    export type RegisterV1OauthRegisterPostMutationBody = ClientRegistrationRequest
    export type RegisterV1OauthRegisterPostMutationError = HTTPValidationError
    export type RegisterV1OauthRegisterPostMutationVariables = {data: ClientRegistrationRequest}

    /**
 * @summary Register
 */
export const useRegisterV1OauthRegisterPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof registerV1OauthRegisterPost>>, TError,RegisterV1OauthRegisterPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof registerV1OauthRegisterPost>>,
        TError,
        RegisterV1OauthRegisterPostMutationVariables,
        TContext
      > => {
      return useMutation(getRegisterV1OauthRegisterPostMutationOptions(options), queryClient);
    }
    /**
 * OAuth token endpoint (POST).
 *
 * Exchanges authorization code for access/refresh tokens (authorization_code grant),
 * refreshes expired access token (refresh_token grant), or issues client credentials
 * access token (client_credentials grant).
 *
 * Grant types:
 * - authorization_code: Exchange code for tokens via exchange_authorization_code()
 * - refresh_token: Refresh access token via refresh_access_token()
 * - client_credentials: Issue access token via generate_client_credentials_token()
 *
 * Success response: JSON with access_token, token_type, expires_in, scope
 * - authorization_code and refresh_token grants also include refresh_token
 * - client_credentials grant does NOT include refresh_token (per OAuth 2.0 spec)
 *
 * Error response: OAuth 2.0 error format (invalid_grant, invalid_request, invalid_client, invalid_scope)
 *
 * Example Request - Authorization Code Grant:
 *     POST /oauth/token
 *     Content-Type: application/json
 *
 *     {
 *       "grantType": "authorization_code",
 *       "code": "abc123def456",
 *       "redirectUri": "http://localhost:3000/callback",
 *       "clientId": "mcp_client",
 *       "codeVerifier": "dBjftJeZ4CVP-mB92K27uhbUJU1p1r_wW1gFWFOEjXk"
 *     }
 *
 * Example Success Response - Authorization Code Grant (200):
 *     {
 *       "accessToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
 *       "tokenType": "Bearer",
 *       "expiresIn": 3600,
 *       "refreshToken": "def456ghi789",
 *       "scope": "read_messages"
 *     }
 *
 * Example Request - Refresh Token Grant:
 *     POST /oauth/token
 *     Content-Type: application/json
 *
 *     {
 *       "grantType": "refresh_token",
 *       "refreshToken": "def456ghi789"
 *     }
 *
 * Example Success Response - Refresh Token Grant (200):
 *     {
 *       "accessToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
 *       "tokenType": "Bearer",
 *       "expiresIn": 3600,
 *       "refreshToken": "ghi789jkl012",
 *       "scope": "read_messages"
 *     }
 *
 * Example Request - Client Credentials Grant:
 *     POST /oauth/token
 *     Content-Type: application/json
 *
 *     {
 *       "grantType": "client_credentials",
 *       "clientId": "dd_client_1234567890abcdef...",
 *       "clientSecret": "abc123def456...",
 *       "scope": "read_messages write_messages"
 *     }
 *
 * Example Success Response - Client Credentials Grant (200):
 *     {
 *       "accessToken": "dd_oauth_eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
 *       "tokenType": "Bearer",
 *       "expiresIn": 3600,
 *       "scope": "read_messages write_messages"
 *     }
 *
 * Example Error Response - Invalid Client (400):
 *     {
 *       "error": "invalid_client",
 *       "errorDescription": "Client authentication failed"
 *     }
 *
 * Example Error Response - Invalid Scope (400):
 *     {
 *       "error": "invalid_scope",
 *       "errorDescription": "Requested scope exceeds client's allowed scope. Invalid scopes: admin"
 *     }
 *
 * Example Error Response - Invalid Grant (400):
 *     {
 *       "error": "invalid_grant",
 *       "errorDescription": "Authorization code has expired"
 *     }
 *
 * Example Error Response - Expired Token (400):
 *     {
 *       "error": "invalid_grant",
 *       "errorDescription": "Refresh token has expired"
 *     }
 *
 * Example Error Response - Invalid Code Verifier (400):
 *     {
 *       "error": "invalid_grant",
 *       "errorDescription": "Invalid PKCE code_verifier"
 *     }
 *
 * Example Error Response - Missing Parameter (400):
 *     {
 *       "error": "invalid_request",
 *       "errorDescription": "Missing required parameter: code"
 *     }
 *
 * Using Bearer Token with MCP Endpoints:
 *     After obtaining access token, use it to authenticate MCP endpoint requests:
 *
 *     GET /api/v1/messages?topicId=550e8400-e29b-41d4-a716-446655440000
 *     Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...
 *
 * Args:
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     body: Token request with grant type and credentials
 *
 * Returns:
 *     OAuthTokenResponse with access token, refresh token, and metadata
 *
 * Raises:
 *     HTTPException 400: If grant validation fails (invalid_request or invalid_grant)
 * @summary Token
 */
export const tokenV1OauthTokenPost = (
    bodyTokenV1OauthTokenPost: BodyTokenV1OauthTokenPost,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {

      const formUrlEncoded = new URLSearchParams();
if(bodyTokenV1OauthTokenPost.client_id !== undefined && bodyTokenV1OauthTokenPost.client_id !== null) {
 formUrlEncoded.append(`client_id`, bodyTokenV1OauthTokenPost.client_id);
 }
if(bodyTokenV1OauthTokenPost.client_secret !== undefined && bodyTokenV1OauthTokenPost.client_secret !== null) {
 formUrlEncoded.append(`client_secret`, bodyTokenV1OauthTokenPost.client_secret);
 }
if(bodyTokenV1OauthTokenPost.code !== undefined && bodyTokenV1OauthTokenPost.code !== null) {
 formUrlEncoded.append(`code`, bodyTokenV1OauthTokenPost.code);
 }
if(bodyTokenV1OauthTokenPost.code_verifier !== undefined && bodyTokenV1OauthTokenPost.code_verifier !== null) {
 formUrlEncoded.append(`code_verifier`, bodyTokenV1OauthTokenPost.code_verifier);
 }
formUrlEncoded.append(`grant_type`, bodyTokenV1OauthTokenPost.grant_type);
if(bodyTokenV1OauthTokenPost.redirect_uri !== undefined && bodyTokenV1OauthTokenPost.redirect_uri !== null) {
 formUrlEncoded.append(`redirect_uri`, bodyTokenV1OauthTokenPost.redirect_uri);
 }
if(bodyTokenV1OauthTokenPost.refresh_token !== undefined && bodyTokenV1OauthTokenPost.refresh_token !== null) {
 formUrlEncoded.append(`refresh_token`, bodyTokenV1OauthTokenPost.refresh_token);
 }
if(bodyTokenV1OauthTokenPost.scope !== undefined && bodyTokenV1OauthTokenPost.scope !== null) {
 formUrlEncoded.append(`scope`, bodyTokenV1OauthTokenPost.scope);
 }

      return apiMutator<OAuthTokenResponse>(
      {url: `/v1/oauth/token`, method: 'POST',
      headers: {'Content-Type': 'application/x-www-form-urlencoded', },
       data: formUrlEncoded, signal
    },
      options);
    }




export const getTokenV1OauthTokenPostMutationKey = () => ['tokenV1OauthTokenPost'] as const;

export const getTokenV1OauthTokenPostMutationOptions = <TError = OAuthErrorResponse | HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tokenV1OauthTokenPost>>, TError,TokenV1OauthTokenPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof tokenV1OauthTokenPost>>, TError,TokenV1OauthTokenPostMutationVariables, TContext> => {

const mutationKey = getTokenV1OauthTokenPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tokenV1OauthTokenPost>>, TokenV1OauthTokenPostMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  tokenV1OauthTokenPost(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TokenV1OauthTokenPostMutationResult = NonNullable<Awaited<ReturnType<typeof tokenV1OauthTokenPost>>>
    export type TokenV1OauthTokenPostMutationBody = BodyTokenV1OauthTokenPost
    export type TokenV1OauthTokenPostMutationError = OAuthErrorResponse | HTTPValidationError
    export type TokenV1OauthTokenPostMutationVariables = {data: BodyTokenV1OauthTokenPost}

    /**
 * @summary Token
 */
export const useTokenV1OauthTokenPost = <TError = OAuthErrorResponse | HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tokenV1OauthTokenPost>>, TError,TokenV1OauthTokenPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tokenV1OauthTokenPost>>,
        TError,
        TokenV1OauthTokenPostMutationVariables,
        TContext
      > => {
      return useMutation(getTokenV1OauthTokenPostMutationOptions(options), queryClient);
    }
